import { bible_bookmark, type PowerSyncDrizzleDB } from "@bso/powersync";
import { patchRowsVerified, patchRowVerified } from "../powersync/verified-write";

/**
 * UPDATE writes on `bible_bookmark` — same window as
 * `../highlights/mutations.ts` (ver `../powersync/verified-write.ts`). El
 * most direct case is the favorite toggle in `verse-actions-bar.tsx`: bookmarking
 * and unbookmarking the SAME verse in the same reading session is the most
 * common gesture in the actions bar. Extracted from `apps/web/src/routes/_app/
 * bookmarks.tsx`, `profile.trash.tsx` y `components/bible/verse-actions-bar.tsx`.
 */

/** Soft delete of a bookmark. */
export async function softDeleteBookmarkMutation(
  db: PowerSyncDrizzleDB,
  id: string,
): Promise<void> {
  const now = new Date().toISOString();
  await patchRowVerified(db, bible_bookmark, bible_bookmark.id, id, {
    deleted_at: now,
    updated_at: now,
  });
}

/** Inversa de {@link softDeleteBookmarkMutation} (undo / papelera). */
export async function restoreBookmarkMutation(db: PowerSyncDrizzleDB, id: string): Promise<void> {
  await patchRowVerified(db, bible_bookmark, bible_bookmark.id, id, {
    deleted_at: null,
    updated_at: new Date().toISOString(),
  });
}

/**
 * BATCH soft delete — the "remove from favorites" toggle in the actions bar
 * actions, already resolved to the list of ids affected by caller (see
 * `verse-actions-bar.tsx`: first SELECT ids by coordinates, then
 * this verified UPDATE by id — never a direct UPDATE by coordinates, which
 * would reopen the same window with no way to reread by id).
 */
export async function softDeleteBookmarksMutation(
  db: PowerSyncDrizzleDB,
  ids: readonly string[],
): Promise<void> {
  const now = new Date().toISOString();
  await patchRowsVerified(db, bible_bookmark, bible_bookmark.id, ids, {
    deleted_at: now,
    updated_at: now,
  });
}
